

import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { RemesasService } from "../../servicios/remesas.service";
import { CobrosPorTipoPagoService } from "../../servicios/cobros-por-tipo-pago.service";
import { AuthenticationService } from "app/servicios";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { AuxJasper, ParametroJasper, Remesas, CobrosPorTipoPago, CobrosPorTipoPagoInput, Cobros, CorteTotal, Privilegios } from "../../entidades/entidades";
import { JasperService } from "../../servicios/jasper.service";
import { DotacionInicialService } from "../../servicios/dotacion-inicial.service";
import { CobrosService } from "app/servicios/cobros.service";
import { CorteTotalService } from "../../servicios/corte-total.service";
import { PrivilegiosService } from 'app/servicios/privilegios.service';
import { Router } from "@angular/router";
import { ThrowStmt } from "@angular/compiler";

@Component({
  selector: "app-remesas",
  templateUrl: "./remesas.component.html",
  styleUrls: ["./remesas.component.css"],
})
export class RemesasComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  remesas: Remesas[];
  public remesasDatos: any;  
  public auxJasper: AuxJasper;
  itemsMenu: MenuItem[];
  columnasTabla: any[];
  clonedRemesas: { [s: string]: Remesas } = {};
  totalDB: number = 0;
  totalCaptura: number = 0;
  privilegiosDrops: boolean = false;
  dotacionInicial: number = 0;
  totales: number[] = [];
  totalesCorte: string = '$0.00';
  remesaTotal: string[];
  privilegioRemesar: boolean = false;
  
  @Input("filters") filters: any;

  //para corte 
  totalCorte: string = '';
  diferencia: string = '$0.00';
  
  _id_usuario_cobro: string;
  display: boolean = false;
  showDialog() {
      this.display = true;
  }

  constructor(
   private remesasService: RemesasService,
   private authenticationService: AuthenticationService,
   private cobrosPorTipoPagoService: CobrosPorTipoPagoService,
   private dotacionInicialService: DotacionInicialService,
   private router: Router,
   private cobrosService: CobrosService,
   private privilegiosService: PrivilegiosService,
   private corteTotalService: CorteTotalService
  ) {}


  async ngOnInit() {
    //this.getAllRemesas();

    // Suscribirse a los cambios en dotacionInicial
    this.dotacionInicialService.dotacionInicial$.subscribe(value => {
      this.dotacionInicial = value;
    });  
    //se suscribe al cambio de la consulta para obtener
    this.corteTotalService.getDatosFiltrados().subscribe(totales => {
      const valoresTotales = totales.map(total => Number(total.total)); // Extraer y convertir
      this.remesaTotal = totales.map(total => total.remesas.toString());
      
      this.totales = valoresTotales; // Guardar en la variable de la clase
      this.totalesCorte = valoresTotales
        .map(valor => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(valor))
        .join(", "); // formato moneda
      this.getPrivilegios();
    });

    if((this.totalesCorte).length == 0) this.totalesCorte = "$0.00";

    
    await this.getPrivilegios();
    // sirve tambien para obtener el valor del corte
    this.getSingleCobros();

    // ===============================================================
    //Opciones del menu
    // ===============================================================
    // prettier-ignore
    this.itemsMenu = [
      {label: "Agregar",   icon: "pi pi-file-o",  command: () => this.add(), },
      //{label: "Guardar",   icon: "pi pi-save",    command: (event) => {this.guardarGridRemesas();} },
      {label: "Refrescar", icon: "pi pi-refresh", command: (event) => {this.getAllRemesas();} },
    ];

    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore
    this.columnasTabla = [
      {field: "operacion",header: "", ordenar: false, styleHeader: "width: 30px;"},
      //{field: "id", header: "Id",ordenar: false, styleHeader: "width: 30px;",},
      //{field: "idUsuarioCaptura", header: "Usuario Captura",ordenar: true, styleHeader: "width: 150px;",},
      //{field: "fechaCaptura", header: "Fecha Captura",ordenar: true, styleHeader: "width: 150px;",},
      {field: "m1000", header: "1000",ordenar: true, styleHeader: "width: 100px;",},
      {field: "q500", header: "500",ordenar: true, styleHeader: "width: 100px;",},
      {field: "d200", header: "200",ordenar: true, styleHeader: "width: 100px;",},
      {field: "c100", header: "100",ordenar: true, styleHeader: "width: 100px;",},
      {field: "c50", header: "50",ordenar: true, styleHeader: "width: 100px;",},
      {field: "v20", header: "20",ordenar: true, styleHeader: "width: 100px;",},
      {field: "d10", header: "10",ordenar: true, styleHeader: "width: 100px;",},
      {field: "totalEfectivo", header: "Total Efectivo",ordenar: true, styleHeader: "width: 100px;",},
      {field: "tarjetaDebito", header: "Tarjeta Debito",ordenar: true, styleHeader: "width: 100px;",},
      {field: "tarjetaCredito", header: "Tarjeta Credito",ordenar: true, styleHeader: "width: 100px;",},
      {field: "cheque", header: "Cheque",ordenar: true, styleHeader: "width: 100px;",},
      {field: "morralla", header: "Morralla",ordenar: true, styleHeader: "width: 100px;",},
      {field: "transferencia", header: "Transferencia",ordenar: true, styleHeader: "width: 100px;",},
      {field: "totalRemesado", header: "Total Remesado",ordenar: true, styleHeader: "width: 100px;",},
      {field: "pagoLinea", header: "Pago Linea",ordenar: true, styleHeader: "width: 100px;",},
      {field: "acciones", header: "",ordenar: false, styleHeader: "width: 30px;",},
    ];


  }
  //===============================================================
  //Agrega renglon en el grid
  //===============================================================
  // prettier-ignore
  add() {
    let remesasNew = new Remesas();
    remesasNew.id = 0;
    remesasNew.numRow = this.remesas.length + 1;
    this.remesas.unshift(remesasNew);
  }

  //===============================================================
  //Funciones de la tabla
  //===============================================================
  // prettier-ignore
  onEditInit(event) {
    let remesasEdit = event.data;
    this.clonedRemesas[remesasEdit.numRow] = { ...remesasEdit };
  }

  calculaRemesas()
  {
    var efe1000 = (<HTMLInputElement>document.getElementById("1000")).value;
    var tot1000 = new Intl.NumberFormat('en-US',{style: 'currency', currency:'USD'}).format(Number(efe1000) * 1000);
    (<HTMLInputElement>document.getElementById("total-1000")).value = tot1000;
    
    var efe500 = (<HTMLInputElement>document.getElementById("500")).value;
    var tot500 = new Intl.NumberFormat('en-US',{style: 'currency', currency:'USD'}).format(Number(efe500) * 500);
    (<HTMLInputElement>document.getElementById("total-500")).value = tot500;
    
    var efe200 = (<HTMLInputElement>document.getElementById("200")).value;
    var tot200 = new Intl.NumberFormat('en-US',{style: 'currency', currency:'USD'}).format(Number(efe200) * 200);
    (<HTMLInputElement>document.getElementById("total-200")).value = tot200;
    
    var efe100 = (<HTMLInputElement>document.getElementById("100")).value;
    var tot100 = new Intl.NumberFormat('en-US',{style: 'currency', currency:'USD'}).format(Number(efe100) * 100);
    (<HTMLInputElement>document.getElementById("total-100")).value = tot100;
    
    var efe50 = (<HTMLInputElement>document.getElementById("50")).value;
    var tot50 = new Intl.NumberFormat('en-US',{style: 'currency', currency:'USD'}).format(Number(efe50) * 50);
    (<HTMLInputElement>document.getElementById("total-50")).value = tot50;
    
    var efe20 = (<HTMLInputElement>document.getElementById("20")).value;
    var tot20 = new Intl.NumberFormat('en-US',{style: 'currency', currency:'USD'}).format(Number(efe20) * 20);
    (<HTMLInputElement>document.getElementById("total-20")).value = tot20;
    
    var efe10 = (<HTMLInputElement>document.getElementById("10")).value;
    var tot10 = new Intl.NumberFormat('en-US',{style: 'currency', currency:'USD'}).format(Number(efe10) * 10);
    (<HTMLInputElement>document.getElementById("total-10")).value = tot10;    
    
    var tarMorralla = Number((<HTMLInputElement>document.getElementById("morralla")).value.toString().replace(/[^0-9\.]+/g, ""));
    var tarMorrallaformat = new Intl.NumberFormat('en-US',{style: 'currency', currency:'USD'}).format(tarMorralla);
    (<HTMLInputElement>document.getElementById("morralla")).value = tarMorrallaformat;

    var totEfectivo = (Number(efe1000)*1000) + (Number(efe500)*500) + (Number(efe200)*200) + (Number(efe100)*100) + (Number(efe50)*50) + (Number(efe20)*20) + (Number(efe10)*10) + Number(tarMorralla);
    var totefe = new Intl.NumberFormat('en-US',{style: 'currency', currency:'USD'}).format(totEfectivo);
    (<HTMLInputElement>document.getElementById("total-efectivo")).value = totefe;

    
    var tarDebito = Number((<HTMLInputElement>document.getElementById("t-debito")).value.toString().replace(/[^0-9\.]+/g, ""));
    var tdebitoformat = new Intl.NumberFormat('en-US',{style: 'currency', currency:'USD'}).format(tarDebito);
    (<HTMLInputElement>document.getElementById("t-debito")).value = tdebitoformat;
    
    var tarCredito = Number((<HTMLInputElement>document.getElementById("t-credito")).value.toString().replace(/[^0-9\.]+/g, ""));
    var tcreditoformat = new Intl.NumberFormat('en-US',{style: 'currency', currency:'USD'}).format(tarCredito);
    (<HTMLInputElement>document.getElementById("t-credito")).value = tcreditoformat;
    
    var tarCheque = Number((<HTMLInputElement>document.getElementById("cheque")).value.toString().replace(/[^0-9\.]+/g, ""));
    var tarChequeformat = new Intl.NumberFormat('en-US',{style: 'currency', currency:'USD'}).format(tarCheque);
    (<HTMLInputElement>document.getElementById("cheque")).value = tarChequeformat;
    
    var tarTransf = Number((<HTMLInputElement>document.getElementById("transf")).value.toString().replace(/[^0-9\.]+/g, ""));
    var tarTransfformat = new Intl.NumberFormat('en-US',{style: 'currency', currency:'USD'}).format(tarTransf);
    (<HTMLInputElement>document.getElementById("transf")).value = tarTransfformat;

    var tarLinea = Number((<HTMLInputElement>document.getElementById("p-linea")).value.toString().replace(/[^0-9\.]+/g, ""));
    var tarLineaformat = new Intl.NumberFormat('en-US',{style: 'currency', currency:'USD'}).format(tarLinea);
    (<HTMLInputElement>document.getElementById("p-linea")).value = tarLineaformat;

    var totRemesado = totEfectivo + tarDebito + tarCredito + tarCheque + tarTransf;
    this.totalCaptura = totRemesado;
    var totrem = new Intl.NumberFormat('en-US',{style: 'currency', currency:'USD'}).format(totRemesado);
    (<HTMLInputElement>document.getElementById("total-remesa")).value = totrem;
    this.totaldif();    
  }
  
  limpiaValores()
  {
    (<HTMLInputElement>document.getElementById("1000")).value = '0';
    (<HTMLInputElement>document.getElementById("total-1000")).value = '$0';
    
    (<HTMLInputElement>document.getElementById("500")).value = '0';
    (<HTMLInputElement>document.getElementById("total-500")).value = '$0';
    
    (<HTMLInputElement>document.getElementById("200")).value = '0';
    (<HTMLInputElement>document.getElementById("total-200")).value = '$0';
    
    (<HTMLInputElement>document.getElementById("100")).value = '0';
    (<HTMLInputElement>document.getElementById("total-100")).value = '$0';
    
    (<HTMLInputElement>document.getElementById("50")).value = '0';;
    (<HTMLInputElement>document.getElementById("total-50")).value = '$0';
    
    (<HTMLInputElement>document.getElementById("20")).value = '0';;
    (<HTMLInputElement>document.getElementById("total-20")).value = '$0';
    
    (<HTMLInputElement>document.getElementById("10")).value = '0';;
    (<HTMLInputElement>document.getElementById("total-10")).value = '$0';

    (<HTMLInputElement>document.getElementById("total-efectivo")).value = '$0';
    
    (<HTMLInputElement>document.getElementById("t-debito")).value = '$0';    
    (<HTMLInputElement>document.getElementById("t-credito")).value = '$0';    
    (<HTMLInputElement>document.getElementById("cheque")).value = '$0';    
    (<HTMLInputElement>document.getElementById("morralla")).value = '$0';
    (<HTMLInputElement>document.getElementById("transf")).value = '$0';
    (<HTMLInputElement>document.getElementById("p-linea")).value = '$0';

    (<HTMLInputElement>document.getElementById("total-remesa")).value = '$0';

    this.getSingleCobros();
  }

  // prettier-ignore
  onEditCancel(event) {
    let remesasEdit = event.data;
    let index = this.remesas.findIndex(
      (obj) => obj.numRow === remesasEdit.numRow
    );
    this.remesas[index] = { ...this.clonedRemesas[remesasEdit.numRow]};
  }

  // prettier-ignore
  async onEditComplete(event) {
    try {
      let remesasEdit = event.data;

      //Valida si hay cambios
      if (
        remesasEdit.id === this.clonedRemesas[remesasEdit.numRow].id &&
        remesasEdit.idUsuarioCaptura === this.clonedRemesas[remesasEdit.numRow].idUsuarioCaptura &&
        remesasEdit.fechaCaptura === this.clonedRemesas[remesasEdit.numRow].fechaCaptura &&
        remesasEdit.m1000 === this.clonedRemesas[remesasEdit.numRow].m1000 &&
        remesasEdit.q500 === this.clonedRemesas[remesasEdit.numRow].q500 &&
        remesasEdit.d200 === this.clonedRemesas[remesasEdit.numRow].d200 &&
        remesasEdit.c100 === this.clonedRemesas[remesasEdit.numRow].c100 &&
        remesasEdit.c50 === this.clonedRemesas[remesasEdit.numRow].c50 &&
        remesasEdit.v20 === this.clonedRemesas[remesasEdit.numRow].v20 &&
        remesasEdit.d10 === this.clonedRemesas[remesasEdit.numRow].d10 &&
        remesasEdit.tarjetaDebito === this.clonedRemesas[remesasEdit.numRow].tarjetaDebito &&
        remesasEdit.tarjetaCredito === this.clonedRemesas[remesasEdit.numRow].tarjetaCredito &&
        remesasEdit.cheque === this.clonedRemesas[remesasEdit.numRow].cheque &&
        remesasEdit.morralla === this.clonedRemesas[remesasEdit.numRow].morralla &&
        remesasEdit.transferencia === this.clonedRemesas[remesasEdit.numRow].transferencia &&
        remesasEdit.totalEfectivo === this.clonedRemesas[remesasEdit.numRow].totalEfectivo &&
        remesasEdit.totalRemesado === this.clonedRemesas[remesasEdit.numRow].totalRemesado &&
        remesasEdit.pagoLinea === this.clonedRemesas[remesasEdit.numRow].pagoLinea 
      ) {
        let index = this.remesas.findIndex((obj) => obj.numRow === remesasEdit.numRow);
        this.remesas[index] = {...this.clonedRemesas[remesasEdit.numRow]};
        return;
      }
      
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por onEditComplete");
    }
  }
  
  //===============================================================
  //Interaccion con servicios
  //===============================================================
  // prettier-ignore
  async guardarRemesas() {
    try {
      
      if(this.privilegioRemesar == false){
          this.muestraMensaje.warning("No tienes el permiso para realizar la Remesa", "top", "center");
          return;
      }
      // COMPROBACION DE REMESAS = CORTE CAJA    if(!(this.totalDB == this.totalCaptura)){ 
      //   throw new Error('La información capturada no coincide \n con lo registrado en la base de datos.');
      // }

      let newRemesas = new Remesas();
      //remesasNew.cambio = true;
      newRemesas.id = 0;
      newRemesas.numRow = 0;
      newRemesas.idUsuarioCaptura = this.authenticationService.currentUserValue.id;
      newRemesas.fechaCaptura = new Date();
      newRemesas.m1000 = Number((<HTMLInputElement>document.getElementById("1000")).value);
      newRemesas.q500 = Number((<HTMLInputElement>document.getElementById("500")).value);
      newRemesas.d200 = Number((<HTMLInputElement>document.getElementById("200")).value);
      newRemesas.c100 = Number((<HTMLInputElement>document.getElementById("100")).value);
      newRemesas.c50 = Number((<HTMLInputElement>document.getElementById("50")).value);
      newRemesas.v20 = Number((<HTMLInputElement>document.getElementById("20")).value);
      newRemesas.d10 = Number((<HTMLInputElement>document.getElementById("10")).value);
      newRemesas.tarjetaCredito = Number((<HTMLInputElement>document.getElementById("t-credito")).value.toString().replace(/[^0-9\.]+/g, ""));
      newRemesas.tarjetaDebito = Number((<HTMLInputElement>document.getElementById("t-debito")).value.toString().replace(/[^0-9\.]+/g, ""));
      newRemesas.cheque = Number((<HTMLInputElement>document.getElementById("cheque")).value.toString().replace(/[^0-9\.]+/g, ""));
      newRemesas.morralla = Number((<HTMLInputElement>document.getElementById("morralla")).value.toString().replace(/[^0-9\.]+/g, ""));
      newRemesas.transferencia = Number((<HTMLInputElement>document.getElementById("transf")).value.toString().replace(/[^0-9\.]+/g, ""));
      newRemesas.totalEfectivo = Number((<HTMLInputElement>document.getElementById("total-efectivo")).value.toString().replace(/[^0-9\.]+/g, ""));
      newRemesas.totalRemesado = Number((<HTMLInputElement>document.getElementById("total-remesa")).value.toString().replace(/[^0-9\.]+/g, ""));
      newRemesas.pagoLinea = Number((<HTMLInputElement>document.getElementById("p-linea")).value.toString().replace(/[^0-9\.]+/g, ""));

      newRemesas.datosAdicionales = JSON.stringify(this.filters);
      await this.remesasService.add(newRemesas).toPromise();


      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
      this.limpiaValores();
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarRemesas");
    }
  }
  
  totaldif() {
    let totalesNum = parseFloat(this.totales.toString());
    let totalRemesas = parseFloat(this.totalCaptura.toString());
  
      let resRem = totalRemesas - totalesNum;
      this.diferencia = '$' + resRem.toFixed(2);
  }

  async getSingleCobros() {
    try {
      let id = new CobrosPorTipoPagoInput();
      id.idUsuarioCobro = Number(this.authenticationService.currentUserValue.id);
      const datoretorno = await this.cobrosPorTipoPagoService
        .getSingle(id)
        .toPromise();


      this.totalDB = 0;

      for (let index = 0; index < Object.keys(datoretorno).length; index++) {
        //console.log(datoretorno[index].medioPago);
        var monto_format = new Intl.NumberFormat('en-US',{style: 'currency', currency:'USD'}).format(datoretorno[index].monto);
        this.totalDB = this.totalDB + Number(datoretorno[index].monto);
        if(datoretorno[index].medioPago == "TARJETA DE DÉBITO"){
          (<HTMLInputElement>document.getElementById("t-debito")).value = monto_format;
        }
        if(datoretorno[index].medioPago == "TARJETA DE CRÉDITO"){
          (<HTMLInputElement>document.getElementById("t-credito")).value = monto_format;
        }
        if(datoretorno[index].medioPago == "TRANSFERENCIA"){
          (<HTMLInputElement>document.getElementById("transf")).value = monto_format;
        }
        if(datoretorno[index].medioPago == "CHEQUE NOMINATIVO"){
          (<HTMLInputElement>document.getElementById("cheque")).value = monto_format;
        }
        if(datoretorno[index].medioPago == "PAGO LINEA"){
          (<HTMLInputElement>document.getElementById("cheque")).value = monto_format;
        }
       }

       this.totalCorte = "$" + this.totalDB + ".00"; // Actualiza el valor de totalCorte

       // se omito calcularRemesas al momento de conseguir cobros para al momento de calcularremesas se haga la restar d totalRemesas y corte, y que no se muestre negativo desde un inicio
      //  this.calculaRemesas();
      

      return datoretorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getSingleCobros");
    }
  }

  async imprimir(){
    try{
      this._id_usuario_cobro = this.authenticationService.currentUserValue.id.toString();
      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.nombreReporte = "CorteParcialRemesas"; 
      this.auxJasper.JasperReport.tipo = "pdf";
      const parametroJasper = new ParametroJasper();
      parametroJasper.nombre = "_id_usuario_cobro";
      parametroJasper.valor = this._id_usuario_cobro;
      await this.auxJasper.ParametroJasper.push(parametroJasper);
      
      //pendiente de comprobar
      let parametroJasper2 = new ParametroJasper();
      parametroJasper2.nombre = "id_user_search";
      parametroJasper2.valor = this.filters.idUsuarioCajero != undefined ? this.filters.idUsuarioCajero + "" : null;
      await this.auxJasper.ParametroJasper.push(parametroJasper2);

      let fechaIni = new ParametroJasper();
      fechaIni.nombre = "fecha_ini";
      fechaIni.valor = this.filters.fecha_apertura + "";
      await this.auxJasper.ParametroJasper.push(fechaIni);

      let fechaFin = new ParametroJasper();
      fechaFin.nombre = "fecha_fin";
      fechaFin.valor = this.filters.fecha_cierre + "";
      await this.auxJasper.ParametroJasper.push(fechaFin);


      await this.showDialog();
    }catch(e){
      this.muestraMensaje.error(e.message, "top", "center");
    }finally{
      console.log("Paso por imprimeSolicitud")
    }
  }


  async imprimirRemesado(){
    try{
      await this.guardarRemesas();

      this._id_usuario_cobro = this.authenticationService.currentUserValue.id.toString();
      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.nombreReporte = "CorteParcialRemesas"; 
      this.auxJasper.JasperReport.tipo = "pdf";
      const parametroJasper = new ParametroJasper();
      parametroJasper.nombre = "_id_usuario_cobro";
      parametroJasper.valor = this._id_usuario_cobro;
      await this.auxJasper.ParametroJasper.push(parametroJasper);
      const parametroJasper2 = new ParametroJasper();
      parametroJasper2.nombre = "par_es_anterior";
      parametroJasper2.valor = "true";
      await this.auxJasper.ParametroJasper.push(parametroJasper2);

      //para obtener las fechas
      let fechaIni = new ParametroJasper();
      fechaIni.nombre = "fecha_ini";
      fechaIni.valor = this.filters.fecha_apertura + "";
      await this.auxJasper.ParametroJasper.push(fechaIni);

      let fechaFin = new ParametroJasper();
      fechaFin.nombre = "fecha_fin";
      fechaFin.valor = this.filters.fecha_cierre + "";
      await this.auxJasper.ParametroJasper.push(fechaFin);

      await this.showDialog();
    }catch(e){
      this.muestraMensaje.error(e.message, "top", "center");
    }finally{
      console.log("Paso por imprimeSolicitud")
    }
  }


  // prettier-ignore
  async addRemesas(remesas) {
    try {
      const datoretorno = await this.remesasService
        .add(remesas)
        .toPromise();
      return datoretorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addRemesas");
    }
  }

  // prettier-ignore
  async getAllRemesas() {
    try {
      const datoRetorno = await this.remesasService.getAll().toPromise();
      for (var i = 0, len = datoRetorno.length; i < len; ++i){
        datoRetorno[i].fechaCaptura = new Date(datoRetorno[i].fechaCaptura);
      }
      this.remesas = datoRetorno;
      for (var i = 0, len = this.remesas.length; i < len; ++i){
        this.remesas[i].numRow = i;
        this.clonedRemesas[this.remesas[i].numRow] = {...this.remesas[i],        };
      } 
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllRemesas");
    }
  }

  // prettier-ignore
  async updateRemesas(remesas: Remesas) {
    try {
      const datoRetorno = await this.remesasService
        .update(remesas)
        .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateRemesas");
    }
  }

  // prettier-ignore
  async deleteRemesas(remesas: Remesas) {
    try {
      const datoRetorno = await this.remesasService
        .delete(remesas.id)
        .toPromise();
      this.getAllRemesas();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por deleteRemesas");
    }
  }


  async aplicaCampos() {
    try { 

      if(Object.keys(this.remesaTotal).length > 0)
      { 
        const jsonString = JSON.parse( this.remesaTotal[0]);

        this.actualizarValor('1000',  jsonString.m1000);
        this.actualizarValor('500',   jsonString.q500);  
        this.actualizarValor('200',   jsonString.d200);  
        this.actualizarValor('100',   jsonString.c100);  
        this.actualizarValor('50',    jsonString.c50);  
        this.actualizarValor('20',    jsonString.v20);  
        this.actualizarValor('10',    jsonString.d10);  
        this.actualizarValor('t-debito',    jsonString.tarjeta_debito);  
        this.actualizarValor('t-credito',   jsonString.tarjeta_credito);  
        this.actualizarValor('cheque',      jsonString.cheque);  
        this.actualizarValor('transf',      jsonString.transferencia);  
        this.actualizarValor('p-linea',     jsonString.pago_linea);   
        this.actualizarValor('morralla',     jsonString.moralla);    
        this.calculaRemesas();
      }

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por aplicaCampos");
    }
  }

  actualizarValor(id: string, valor: string): void {
    const input = document.getElementById(id) as HTMLInputElement;
    if (input) input.value = valor;
  }

  async getPrivilegios() {
    try {

      let objUrl = new Privilegios();
      objUrl.descripcion = this.router.url + '/consulta_remesa';
      let consultaRemesa = await this.privilegiosService.GetPrivilegioByRoute(objUrl).toPromise();
      this.privilegiosDrops = consultaRemesa ? true : false; 

      //obtenemos el privilegio para poder realizar la remesa
      let privRemesar = new Privilegios();
      privRemesar.uuid = '91eda4dd-4ffd-4c82-bd2a-50ca2c90f973';
      let conPrivilegio = await this.privilegiosService.GetPrivilegioByUUID(privRemesar).toPromise();
      this.privilegioRemesar = conPrivilegio ? true : false;



      if(this.privilegiosDrops)
      {
        this.aplicaCampos();
      } 
 

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getPrivilegios");
    }
  }

}